export default "__VITE_ASSET__8861b22c__"